<template>
  <div
    v-if="show"
    class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
    @click.self="handleClose"
  >
    <div class="bg-white rounded-2xl p-6 w-[90%] max-w-md shadow-xl">
      <div class="flex justify-between items-center mb-4">
        <h2 class="text-lg font-bold text-blue">
          {{ $t("orders.billing-qr") }}
        </h2>
        <button
          class="p-2 rounded-full hover:bg-gray-100 transition"
          @click="handleClose"
        >
          <c-icon name="CloseRound" size="1.2rem" class="text-gray-400" />
        </button>
      </div>
      <div class="text-gray-400 text-sm mb-4">
        {{ $t("orders.billing-qr-scan-description") }}
      </div>
      <div
        class="relative mx-auto flex aspect-square max-h-[min(56vh,420px)] w-full max-w-[420px] items-center justify-center overflow-hidden rounded-xl bg-black"
      >
        <qrcode-stream
          v-if="!loading"
          class="absolute inset-0"
          @detect="onDecode"
          @camera-on="onCameraOn"
        />
        <div
          v-if="!loading"
          class="absolute left-1/2 top-1/2 z-[1] flex h-[70%] w-[70%] -translate-x-1/2 -translate-y-1/2 flex-wrap content-between justify-between"
        >
          <div
            class="h-[34%] w-[34%] animate-pulse rounded-tl-full border-l-[7px] border-t-[7px]"
            :class="{
              'border-green': qrDetected,
              'border-white': !qrDetected,
            }"
          ></div>
          <div
            class="h-[34%] w-[34%] animate-pulse rounded-tr-full border-r-[7px] border-t-[7px]"
            :class="{
              'border-green': qrDetected,
              'border-white': !qrDetected,
            }"
          ></div>
          <div
            class="h-[34%] w-[34%] animate-pulse rounded-bl-full border-b-[7px] border-l-[7px]"
            :class="{
              'border-green': qrDetected,
              'border-white': !qrDetected,
            }"
          ></div>
          <div
            class="h-[34%] w-[34%] animate-pulse rounded-br-full border-b-[7px] border-r-[7px]"
            :class="{
              'border-green': qrDetected,
              'border-white': !qrDetected,
            }"
          ></div>
        </div>
        <c-loading-spinner v-else />
      </div>
      <div
        class="flex flex-row items-center justify-center mt-6"
        :class="{ 'opacity-50 pointer-events-none': loading }"
      >
        <button
          class="px-6 py-3 rounded-xl font-semibold border transition hover:opacity-90"
          :style="{ borderColor: accentColor, color: accentColor }"
          @click="handleClose"
        >
          {{ $t("cancel") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { QrcodeStream } from "vue-qrcode-reader";
import CIcon from "../../../core-ui/src/components/CIcon.vue";
import CLoadingSpinner from "../../../core-ui/src/components/CLoadingSpinner.vue";
import api from "@/api";
import { mapState } from "pinia";
import { authStore } from "@/stores/auth";

export default {
  name: "AddOrderBillingQr",
  components: {
    QrcodeStream,
    CIcon,
    CLoadingSpinner,
  },
  data() {
    return {
      loading: false,
      qrDetected: false,
      show: false,
    };
  },
  props: {
    customerId: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState(authStore, ["branding"]),
    accentColor() {
      return this.branding?.accentColor || "#6B9AE1";
    },
  },
  mounted() {
    this.show = true;
  },
  methods: {
    handleClose() {
      this.show = false;
      this.$emit("close");
    },
    async onCameraOn(promise) {
      try {
        await promise;
      } catch (e) {
        this.$notificationGenerator.error(
          this.$t("orders.billing-qr-camera-error")
        );
      }
    },
    async onDecode(result) {
      if (this.loading || !result?.length) return;
      this.qrDetected = true;
      this.loading = true;
      try {
        await api.post(`/customer/${this.customerId}/orderBillingQr`, {
          qrData: result[0].rawValue,
        });
        this.$notificationGenerator.create({
          title: this.$t("orders.order-added-successfully"),
          type: "success",
          duration: 3000,
        });
        this.$emit("order-added");
        this.handleClose();
      } catch (e) {
        this.$notificationGenerator.error(
          this.$t("orders.billing-qr-not-valid")
        );
      }
      this.qrDetected = false;
      this.loading = false;
    },
  },
};
</script>

<style scoped>
:deep(video) {
  height: 100%;
  object-fit: cover;
  width: 100%;
}
</style>
